<template>
  <div>
    <div
      v-if="
        user.grant.verify.list == true ||
        user.grant.verify.create == true ||
        user.grant.verify.check == true
      "
    >
      <div class="search_box mb-10">
        <p class="w-strong mb-5">Liste des paiements à vérifier</p>
        <div class="search_box_content">
          <vs-input
            v-model="model.date_debut"
            class="w-full"
            type="date"
            label="Date début"
          ></vs-input>
          <vs-input
            :min="model.date_debut"
            v-model="model.date_fin"
            class="w-full"
            type="date"
            label="Date fin"
          ></vs-input>
          <vs-input
            v-model="model.search"
            class="w-full"
            type="number"
            label="Numéro"
          ></vs-input>
          <vs-button
            @click="getData"
            class="z-8 mt-5"
            color="primary"
            type="filled"
            >Filtrer</vs-button
          >
        </div>
      </div>
      <div>
        <vs-table ref="table" :max-items="10" :data="data">
          <div
            slot="header"
            class="
              flex flex-wrap-reverse
              items-center
              flex-grow
              justify-between
            "
          >
            <div
              class="
                flex flex-wrap-reverse
                items-center
                data-list-btn-container
              "
            >
              <div
                @click="refresh()"
                class="
                  btn-add-new
                  p-3
                  mb-4
                  mr-4
                  rounded-lg
                  cursor-pointer
                  flex
                  items-center
                  justify-center
                  text-lg
                  font-medium
                  text-base text-primary
                  border border-solid border-primary
                "
              >
                <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary">Actualiser</span>
              </div>
            </div>
          </div>
          <template slot="thead">
            <vs-th>Type de consultation</vs-th>
            <vs-th>Numéro</vs-th>
            <vs-th>Montant</vs-th>
            <vs-th>Date et heure opération</vs-th>
            <vs-th>Actions</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <span class="">{{ tr.consultation }} </span>
                </vs-td>
                <vs-td>
                  <span class="">{{ tr.phone }} </span>
                </vs-td>
                <vs-td>
                  <span class="">{{ tr.amount }} </span>
                </vs-td>
                <vs-td>
                  <span class="">{{ parseDate(tr.created_at) }} </span>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="flex">
                    <!-- <vx-tooltip text="Vérifier le paiement">
                      <feather-icon
                        v-if="tr.id != currentId"
                        @click="checkPayment(tr)"
                        style="cursor: pointer"
                        icon="CheckIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        class="mr-2"
                      />
                    </vx-tooltip> -->
                    <vx-tooltip text="Créer le paiement">
                      <feather-icon
                        @click="createPayment(tr)"
                        style="cursor: pointer"
                        icon="PlusIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        class="mr-2"
                      />
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
        <vs-pagination
          v-if="last_page && model.page"
          :total="last_page"
          v-model="model.page"
        ></vs-pagination>
      </div>
    </div>
    <div v-else>
      <div class="h-screen flex w-full bg-img">
        <div
          class="
            vx-col
            flex
            items-center
            justify-center
            flex-col
            sm:w-1/2
            md:w-3/5
            lg:w-3/4
            xl:w-1/2
            mx-auto
            text-center
          "
        >
          <img
            src="@/assets/images/pages/404.png"
            alt="graphic-404"
            class="mx-auto mb-4 max-w-full"
          />
          <h1 class="sm:mx-0 mx-4 mb-12 text-3xl d-theme-heading-color">
            404 - Page introuvable!
          </h1>
          <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-heading-color">
            La page que vous demandez est introuvable
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { _buildQuery, format } from "../../helper/helper";
import moment from "moment";

export default {
  watch: {
    "model.page": function () {
      this.getData();
    },
  },
  data: () => ({
    last_page: 1,
    data: [],
    model: {
      page: 1,
      date_debut: "",
      date_fin: "",
      search: "",
    },
    index: null,
    currentId: null,
  }),
  created() {
    this.user = JSON.parse(localStorage.getItem("user_cnhu"));
  },
  computed: {},
  mounted() {
    if (
      this.user.grant.verify.list ||
      this.user.grant.verify.check ||
      this.user.grant.verify.create
    ) {
      const d = new Date();
      this.model.date_debut = moment(d).format("YYYY-MM-DD");
      this.model.date_fin = moment(d).format("YYYY-MM-DD");
      this.getData();
    }
  },
  methods: {
    checkPayment(item) {
      if (item.id != this.currentId) {
        if (
          confirm("Vous êtes sur le point de vérifier l'état de ce paiement")
        ) {
          this.$vs.loading();
          this.$http
            .post("/payments/check", {
              phone: item.phone,
              service: item.service,
              referency: item.payment_referency,
            })
            .then((response) => {
              this.$vs.loading.close();
              if (response.data.status === true) {
                this.currentId = item.id;
                this.$vs.notify({
                  title: "Succès",
                  text: "Ce paiement a été vérifié vous pouvez passer à la création",
                  color: "success",
                  iconPack: "feather",
                  icon: "icon-check",
                  position: "top-right",
                });
              } else {
                this.$vs.notify({
                  title: "Erreur",
                  text: "Ce paiement a échoué",
                  color: "danger",
                  iconPack: "feather",
                  icon: "icon-check",
                  position: "top-right",
                });
              }
            })
            .catch((error) => {
              this.$vs.loading.close();
              if (error.response.status === 401) {
                this.$vs.notify({
                  title: "Erreur",
                  text: "Votre session a expiré",
                  color: "danger",
                  iconPack: "feather",
                  icon: "icon-check",
                  position: "top-right",
                });
                this.$router.push({ name: "page-login" });
              }
            });
        }
      }
    },
    getSearch() {
      this.model.page = 1;
      this.getData();
    },
    refresh() {
      const d = new Date();
      this.model.search = "";
      this.model.date_debut = moment(d).format("YYYY-MM-DD");
      this.model.date_fin = moment(d).format("YYYY-MM-DD");
      this.model.page = 1;
      this.getData();
    },
    parseFormat(amount) {
      return format(amount);
    },
    parseDate(date) {
      return moment(date).format("DD-MM-YYYY H:mm");
    },
    createPayment(model) {
      if (confirm("Voulez-vous vraiment créer ce paiement")) {
        this.$vs.loading();
        this.$http
          .post("/payments/create-after-fail", { id: model.id })
          .then((response) => {
            this.$vs.loading.close();
            if (response.data.status === true) {
              const index = this.data.indexOf(model);
              this.data.splice(index, 1);
              this.$vs.notify({
                title: "Succès",
                text: "Opération réussie",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right",
              });
            } else {
              this.$vs.notify({
                title: "Erreur",
                text: "Une erreur est survenue lors de l'opération",
                color: "danger",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right",
              });
            }
          })
          .catch((error) => {
            this.$vs.loading.close();
            if (error.response.status === 401) {
              this.$vs.notify({
                title: "Erreur",
                text: "Votre session a expiré",
                color: "danger",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right",
              });
              this.$router.push({ name: "page-login" });
            }
          });
      }
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/payments/verify" + _buildQuery(this.model))
        .then((response) => {
          this.data = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "page-login" });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.table_box {
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  min-height: 80px;
  padding: 10px;
  width: 100%;
}
.onglet {
  display: grid;
  grid-template-columns: 120px 120px;
  grid-gap: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
.active_onglet {
  border-bottom: 4px solid #8c8bbf;
  //box-shadow: 0px 0px 6px rgba(115, 103, 240, 0.45277);
}
.search_box {
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  min-height: 80px;
  padding: 10px;
  width: 100%;
}
.search_box_content {
  display: grid;
  grid-template-columns: 240px 240px 230px 110px;
  grid-gap: 10px;
}
.z-8 {
  height: 40px;
}
@media only screen and (max-width: 935px) {
  .search_box_content {
    display: grid !important;
    grid-template-columns: 180px 180px 180px 110px !important;
    grid-gap: 10px !important;
  }
}
@media only screen and (max-width: 740px) {
  .search_box_content {
    display: grid !important;
    grid-template-columns: 150px 150px 110px 110px !important;
    grid-gap: 10px !important;
  }
}
@media only screen and (max-width: 640px) {
  .search_box_content {
    display: grid !important;
    grid-auto-flow: row;
    grid-template-columns: 1fr !important;
    grid-gap: 10px !important;
  }
}
.w-strong {
  font-weight: bold;
}
</style>
